export class ObjectRetranslationModel {
  ObjectId: number;
  OverridenId?: string;

  constructor(data?: any) {
    if (data) {
      this.init(data);
    }
  }

  init(data: any): void {
    this.ObjectId = data.objectId || 0;
    this.OverridenId = data.overridenId;
  }

  static fromJS(data: any): ObjectRetranslationModel {
    return new ObjectRetranslationModel(data);
  }
}
